exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".creator-nvidia__section__body p {\n  margin: 0;\n}", ""]);

// exports
